import Vue from "vue";
import Vuex from "vuex";
import common from "./module-common";
import user from "./user-module";
import chapter from "./module-chapter";
import video from "./module-video";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    common,
    user,
    chapter,
    video
  }
});
